<template>
  <v-container>
    <v-overlay :value="overlay" z-index="100">
      <v-progress-circular
        :size="50"
        color="grey lighten-4"
        indeterminate
      ></v-progress-circular>
    </v-overlay>

    <v-layout justify-center class="ma-0 mt-4">
      <v-flex xs12 md12>
        <v-card flat class="pl-3 pr-3">
          <v-card-title class="align-start">
            <div class="flex-fill">
              <div class="mb-3 d-flex text-center">
                <v-btn
                  v-if="galeria.status === 'C' || galeria.status == 'E'"
                  class="mr-2"
                  elevation="0"
                  text
                  color="primary"
                  :disabled="
                    galeria.desativar === 'S' || galeria.status == 'E'
                      ? true
                      : false
                  "
                  @click="desativar('R')"
                >
                  <v-icon left>mdi-checkbox-marked-outline</v-icon>
                  <span>Reprovar</span>
                </v-btn>
                <v-btn
                  v-if="galeria.status === 'R' || galeria.status === 'P'"
                  class="mr-2"
                  elevation="0"
                  text
                  color="primary"
                  :disabled="
                    galeria.desativar === 'S' || galeria.status == 'E'
                      ? true
                      : false
                  "
                  @click="desativar('C')"
                >
                  <v-icon left>mdi-checkbox-marked-outline</v-icon>
                  <span>Aprovar</span>
                </v-btn>

                <v-btn
                  class="mr-2"
                  elevation="0"
                  text
                  color="primary"
                  @click="desativarPorId"
                >
                  <template v-if="galeria.desativar === 'S'">
                    <v-icon left>mdi-eye</v-icon>
                    <span>Ativar</span>
                  </template>
                  <template v-else>
                    <v-icon left>mdi-eye-off</v-icon>
                    <span>Desativar</span>
                  </template>
                </v-btn>

                <v-btn
                  class="mr-2"
                  elevation="0"
                  text
                  color="primary"
                  :to="`/galerias/${galeria.id}/editar`"
                  :disabled="galeria.desativar === 'S' ? true : false"
                >
                  <v-icon left>mdi-pencil</v-icon>
                  <span>Editar</span>
                </v-btn>
                <v-btn
                  elevation="0"
                  text
                  color="error"
                  @click="$refs.deleteGaleria.request()"
                  :disabled="galeria.status == 'E'"
                >
                  <v-icon left>mdi-delete</v-icon>
                  <span>Excluir</span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" persistent max-width="400px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      elevation="0"
                      v-on="on"
                      :disabled="
                        galeria.status == 'R' ||
                        galeria.desativar == 'S' ||
                        galeria.status == 'P'
                          ? true
                          : false
                      "
                    >
                      <span>Enviar</span>
                      <v-icon right small>mdi-send</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-form v-model="valid" ref="form">
                      <v-card-title>
                        <span class="headline">Enviar para:</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" md="12" lg="12">
                              <v-autocomplete
                                v-if="galeria.tipo_galeria_id == 2"
                                :items="alunos && alunos"
                                label="Alunos"
                                multiple
                                clearable
                                :search-input.sync="searchAluno"
                                :loading="loading"
                                :item-text="nome_aluno && nome_aluno"
                                :item-value="id_aluno"
                                v-model="pessoas.idPessoas"
                                required
                                :rules="rules"
                              ></v-autocomplete>
                              <v-autocomplete
                                v-if="galeria.tipo_galeria_id == 1"
                                :items="turmas && turmas"
                                label="Turmas"
                                :item-text="
                                  turma =>
                                    `${turma &&
                                      turma.serie &&
                                      turma.serie.nome &&
                                      turma.serie.nome} - ${turma &&
                                      turma.nome &&
                                      turma.nome} - ${turma &&
                                      turma.serie &&
                                      turma.serie.nivel &&
                                      turma.serie.nivel.nome &&
                                      turma.serie.nivel.nome}`
                                "
                                item-value="id"
                                multiple
                                clearable
                                v-model="turmas_payload.idTurmas"
                                required
                                :rules="rules"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="cancelar"
                          >Cancelar</v-btn
                        >
                        <v-btn color="blue darken-1" text @click="enviar"
                          >Enviar</v-btn
                        >
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <p class="title primary--text mt-3 mb-3">
              <v-icon color="primary" left>mdi-file-document-edit</v-icon>
              <span>{{ galeria.titulo }}</span>
            </p>
            <v-chip small class="mr-2">
              <v-icon small left>mdi-calendar</v-icon>
              <span>{{ moment(galeria.data).format('LL') }}</span>
            </v-chip>
            <v-chip v-if="galeria.desativar === 'S'" dark avatar small>
              <v-icon left small>mdi-eye-off</v-icon>
              <span>Desativado</span>
            </v-chip>
            <v-chip
              v-if="galeria.status === 'P' && galeria.desativar === 'N'"
              color="warning"
              avatar
              small
            >
              <v-icon left small>mdi-timer-sand</v-icon>
              <span>Pendente</span>
            </v-chip>
            <v-chip
              v-else-if="galeria.status === 'A' && galeria.desativar === 'N'"
              color="primary"
              avatar
              small
            >
              <v-icon left small>mdi-clock-outline</v-icon>
              <span>Agendado</span>
            </v-chip>
            <v-chip
              v-else-if="galeria.status === 'E' && galeria.desativar === 'N'"
              color="success"
              avatar
              small
            >
              <v-icon left small>mdi-check</v-icon>
              <span>Publicado</span>
            </v-chip>
            <v-chip
              v-else-if="galeria.status === 'C' && galeria.desativar === 'N'"
              avatar
              small
            >
              <v-icon left small>mdi-file-document-box-check</v-icon>
              <span>Cadastrado</span>
            </v-chip>
            <v-chip
              v-else-if="galeria.status === 'R' && galeria.desativar === 'N'"
              avatar
              small
              dark
            >
              <v-icon left small>mdi-file-document-box-remove</v-icon>
              <span>Reprovado</span>
            </v-chip>
            <p class="mt-3">{{ galeria.descricao }}</p>
            <v-btn
              class="primary mr-4 mt-3 mb-4"
              small
              @click="$refs.upload.click()"
            >
              <v-icon left>mdi-image-plus</v-icon>Adicionar foto
            </v-btn>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout class="mt-3" wrap>
      <v-dialog v-model="dialogEnviar" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Enviando foto...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCarregar" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Carregando fotos
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <input
        type="file"
        ref="upload"
        accept="image/*"
        multiple
        @change="handlerFoto"
        v-show="false"
      />
      <v-flex md12 xs12 lg12 class="mt-3">
        <v-layout wrap>
          <v-flex md3 xs12 lg3 v-for="img in images" :key="img">
            <v-card class="mt-3" width="250">
              <silentbox-single :src="img" :description="galeria.descricao">
                <v-img :src="img" height="200" aspect-ratio="1" contain></v-img>
              </silentbox-single>
              <v-card-text align="center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="error"
                      @click="$refs.deteleFile.request(img)"
                    >
                      <v-icon lef>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir foto</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      v-on="on"
                      text
                      color="success"
                      :disabled="img.indexOf('capa') >= 0 ? true : false"
                      @click="escolherCapa(img)"
                    >
                      <v-icon lef>mdi-image</v-icon>
                    </v-btn>
                  </template>
                  <span>Escolher como capa</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <confirm ref="deteleFile" :confirm-fn="excluirArquivo"
      >Deseja excluir esta foto?</confirm
    >
    <confirm ref="deleteGaleria" :confirm-fn="excluirGaleria"
      >Tem certeza que deseja excluir esta galeria?</confirm
    >
    <confirm ref="deleteAgenda" :confirm-fn="deletarAgenda"
      >Tem certeza que deseja excluir esta agenda?</confirm
    >
    <v-snackbar v-model="alerta" :timeout="3000" :color="cor">
      {{ textoAlerta }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { Galeria, Anexos, Turma, Aluno, Agenda } from '../../service'
import Confirm from '../../components/Confirm'

export default {
  components: { Confirm },
  data() {
    return {
      overlay: false,
      cor: null,
      alerta: false,
      textoAlerta: '',
      galeria: '',
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      images: [],
      menu1: false,
      menu2: false,
      time: this.moment().format('HH:mm'),
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      dialogEnviar: false,
      dialogAgendar: false,
      dialogCarregar: false,
      dialog: false,
      alunos: [],
      turmas: [],
      turmas_payload: {
        idTurmas: null
      },
      pessoas: {
        idPessoas: null
      },
      delay: 1000,
      searchAluno: null,
      loading: false,
      rules: [v => !!v || 'Campo requerido.'],
      valid: true,
      agenda: {
        id_item: this.$route.params.id,
        funcao_id: '',
        horario_data_envio: this.date
      },
      agendados: []
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    }
  },
  watch: {
    searchAluno: {
      deep: true,
      handler() {
        clearTimeout(this.delay)
        if (this.searchAluno && this.searchAluno.length > 2) {
          this.loading = true
          this.delay = setTimeout(() => this.loadAlunos(), 500)
          this.loading = false
        }
      }
    }
  },
  async created() {
    this.overlay = true
    this.turmas = await Turma.findAll({ escola: this.escola })
    await this.loadGaleria()
    await this.loadImgs()
    this.overlay = false
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    async load_table() {
      this.agendados = await Agenda.atividadesAgendadas(
        this.galeria.id,
        this.galeria.funcao_id,
        this.escola
      )
    },
    async agendar() {
      this.agenda.horario_data_envio = this.date + ' ' + this.time
      this.agenda.funcao_id = this.galeria.funcao_id
      await Agenda.save(this.agenda, { escola: this.escola })
      this.dialogAgendar = false
      await this.load_table()
    },
    async desativarPorId() {
      this.galeria = await Galeria.desativarPorID(this.galeria.id, this.escola)
      await this.loadGaleria()
    },
    async desativar(novoStatus) {
      this.galeria = await Galeria.desativar(
        this.galeria.id,
        novoStatus,
        this.escola
      )
      await this.loadGaleria()
    },
    async loadGaleria() {
      this.galeria = await Galeria.findById(this.$route.params.id, {
        escola: this.escola
      })
      await this.load_table()
    },
    async handlerFoto() {
      const anexo = this.$refs.upload.files
      this.dialogEnviar = true
      await Galeria.setAnexos(this.galeria.id, anexo, this.escola)
      await this.loadImgs()
      this.dialogEnviar = false
    },
    async loadImgs() {
      this.dialogCarregar = true
      const urls = await Galeria.getAnexos(this.galeria.id, this.escola)
      while (this.images.length) {
        this.images.pop()
      }
      for (let i = 0; i < urls.data.length; i++) {
        const img = await Anexos.getURL(urls.data[i], this.escola)
        this.images.push(img.data)
      }
      this.dialogCarregar = false
    },
    async excluirArquivo(url) {
      let imgUrl = url.split('?')[0].split('/galeria')[1]
      const letra = eval('/' + '%20' + '/g')
      imgUrl = imgUrl.replace(letra, ' ')
      const deletedFile = await Anexos.deteleFile({
        pathFile: 'galeria' + imgUrl,
        escola: this.escola
      })

      if (deletedFile.data) {
        // setTimeout(() => {
        //   this.loadImgs()
        // }, 700)
        this.images = this.images.filter(item => item !== url)
      }
    },
    async loadAlunos() {
      this.alunos = await Aluno.filter({
        search: this.searchAluno,
        escola: this.escola
      })
    },
    nome_aluno(aluno) {
      return `${aluno &&
        aluno.pessoa &&
        aluno.pessoa.nome &&
        aluno.pessoa.nome}`
    },
    id_aluno(aluno) {
      return `${aluno.pessoa_id}`
    },
    async enviar() {
      if (this.galeria.tipo_galeria_id == 1) {
        if (this.$refs.form.validate()) {
          try {
            await Galeria.enviar(this.galeria.id, this.turmas_payload, {
              escola: this.escola
            })
            setTimeout(() => (this.dialog = false), 500)
            await this.loadGaleria()
            this.alerta = true
            this.textoAlerta = 'Galeria enviada com sucesso.'
          } catch (erro) {
            console.warn(erro)
            this.alerta = true
            this.textoAlerta = 'Houve um erro ao enviar a galeria'
            this.cor = 'red'
          }
        }
      } else if (this.galeria.tipo_galeria_id == 2) {
        if (this.$refs.form.validate()) {
          try {
            await Galeria.enviar(this.galeria.id, this.pessoas, {
              escola: this.escola
            })
            setTimeout(() => (this.dialog = false), 500)
            this.loadGaleria()
            this.alerta = true
            this.textoAlerta = 'Galeria enviada com sucesso.'
          } catch (erro) {
            console.warn(erro)
            this.alerta = true
            this.textoAlerta = 'Houve um erro ao enviar a galeria'
            this.cor = 'red'
          }
        }
      }
    },
    cancelar() {
      this.turmas_payload.idTurmas = null
      this.pessoas.idPessoas = null
      this.dialog = false
    },
    async excluirGaleria() {
      try {
        await Galeria.delete(this.galeria.id, { escola: this.escola })
        this.$router.back()
      } catch (error) {
        //console.log(error)
      }
    },
    async deletarAgenda(id) {
      await Agenda.delete(id, { escola: this.escola })
      await this.load_table()
    },
    async escolherCapa(url) {
      let imgUrl = url.split('?')[0].split('/galeria')[1]
      const letra = eval('/' + '%20' + '/g')
      imgUrl = imgUrl.replace(letra, ' ')

      const img = {
        nomeAntigo: 'galeria' + imgUrl
      }
      //const capa = imgUrl.split('/')[2].split('.')[0]
      try {
        if (imgUrl.indexOf('capa') < 0) {
          await Galeria.setCapa(this.galeria.id, img, {
            escola: this.escola
          })
          this.cor = 'default'
          this.alerta = true
          this.textoAlerta = 'Foto adicionada a capa da galeria!'
          await this.loadImgs()
        } else {
          this.cor = 'warning'
          this.alerta = true
          this.textoAlerta = 'Essa foto já é capa!'
        }
      } catch (error) {
        this.color = 'error'
        this.alerta = true
        this.textoAlerta = error
      }
    }
  }
}
</script>

<style scoped></style>
